/**
 * Normalizes an email address to lowercase and trims whitespace.
 * This ensures consistent email storage and lookup to prevent duplicate user records.
 *
 * @param {string} email - The email address to normalize
 * @returns {string} The normalized email address in lowercase with trimmed whitespace
 */
export function normalizeEmail(email: string): string {
  if (typeof email !== 'string') {
    return email;
  }
  return email.toLowerCase().trim();
}

